class Header extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const selected = this.getAttribute('data-selected')
        this.querySelector(`#${selected}`).classList.add('is-selected')
    }
}

customElements.define("cstm-header-bar", Header);